import { SearchState } from '../types';

const startSearchSessionReducer = (state: SearchState) => {
  state.searchSessionId = `${new Date().getTime()}-${Math.random() * 1000000}`;
};

export default startSearchSessionReducer;
